import { Instance } from 'mobx-state-tree';
import { ProjectStopUnschedulingDtoModelBase } from './ProjectStopUnschedulingDtoModel.base';

/* The TypeScript type of an instance of ProjectStopUnschedulingDtoModel */
export interface ProjectStopUnschedulingDtoModelType extends Instance<typeof ProjectStopUnschedulingDtoModel.Type> {}

/* A graphql query fragment builders for ProjectStopUnschedulingDtoModel */
export { selectFromProjectStopUnschedulingDto, projectStopUnschedulingDtoModelPrimitives, ProjectStopUnschedulingDtoModelSelector } from './ProjectStopUnschedulingDtoModel.base';

/**
 * ProjectStopUnschedulingDtoModel
 *
 * Stop unscheduling
 */
export const ProjectStopUnschedulingDtoModel = ProjectStopUnschedulingDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
